export default "__VITE_ASSET__CF314ew9__"